<template>
  <form>
    <div class="uk-grid uk-grid-small">
      <div
        class="uk-width-1-1 uk-width-1-2@m"
        :class="{ 'dcs-has-error': v.firstName.$dirty && v.firstName.$invalid }"
      >
        <label>First Name</label>
        <input
          :value="mailingAddress.firstName"
          type="text"
          class="uk-input dcs-input"
          name="first_name"
          autocomplete="given-name"
          @input="onInput('firstName', $event.target.value)"
        />
        <div
          class="uk-text-danger"
          v-if="v.firstName.$dirty && v.firstName.$invalid"
        >Please enter your first name.</div>
      </div>
      <div
        class="uk-width-1-1 uk-width-1-2@m"
        :class="{ 'dcs-has-error': v.lastName.$dirty && v.lastName.$invalid }"
      >
        <label>Last Name</label>
        <input
          :value="mailingAddress.lastName"
          type="text"
          class="uk-input dcs-input"
          name="last_name"
          autocomplete="family-name"
          @input="onInput('lastName', $event.target.value)"
        />
        <div
          class="uk-text-danger"
          v-if="v.lastName.$dirty && v.lastName.$invalid"
        >Please enter your last name.</div>
      </div>
      <div
        class="uk-width-1-1 uk-width-1-2@m"
        :class="{ 'dcs-has-error': v.line1.$dirty && v.line1.$invalid }"
      >
        <label>Address Line 1</label>
        <input
          :value="mailingAddress.line1"
          type="text"
          class="uk-input dcs-input"
          name="address_line1"
          autocomplete="shipping address-line1"
          @input="onInput('line1', $event.target.value)"
        />
        <div
          class="uk-text-danger"
          v-if="v.line1.$dirty && v.line1.$invalid"
        >Please enter a valid street address.</div>
      </div>
      <div
        class="uk-width-1-1 uk-width-1-2@m"
        :class="{ 'dcs-has-error': v.line2.$dirty && v.line2.$invalid }"
      >
        <label>Address Line 2</label>
        <input
          :value="mailingAddress.line2"
          type="text"
          class="uk-input dcs-input"
          name="address_line2"
          autocomplete="address-line2"
          placeholder="Unit/Apt # (Optional)"
          @input="onInput('line2', $event.target.value)"
        />
      </div>
      <div
        class="uk-width-1-1 uk-width-1-2@m"
        :class="{ 'dcs-has-error': v.city.$dirty && v.city.$invalid }"
      >
        <label>City</label>
        <input
          :value="mailingAddress.city"
          type="text"
          name="address_city"
          class="uk-input dcs-input"
          autocomplete="address-level2"
          @input="onInput('city', $event.target.value)"
        />
        <div
          class="uk-text-danger"
          v-if="v.city.$dirty && v.city.$invalid"
        >Please enter a valid city.</div>
      </div>
      <div
        class="uk-width-1-1 uk-width-1-4@m"
        :class="{ 'dcs-has-error': v.region.$dirty && v.region.$invalid }"
      >
        <label>State</label>
        <select
          :value="mailingAddress.region"
          class="uk-select"
          name="address_region"
          autocomplete="address-level1"
          @change="onInput('region', $event.target.value)"
        >
          <option v-for="option in regions" :key="option" :value="option">
            {{
            option
            }}
          </option>
        </select>
        <div
          class="uk-text-danger"
          v-if="v.region.$dirty && v.region.$invalid"
        >Please select a state.</div>
      </div>
      <div
        class="uk-width-1-1 uk-width-1-4@m"
        :class="{ 'dcs-has-error': v.postal_code.$dirty && v.postal_code.$invalid }"
      >
        <label>Postal Code</label>
        <input
          :value="mailingAddress.postal_code"
          type="text"
          class="uk-input dcs-input"
          name="address_postal_code"
          autocomplete="postal-code"
          @input="onInput('postal_code', $event.target.value)"
        />
        <div
          class="uk-text-danger"
          v-if="v.postal_code.$dirty && v.postal_code.$invalid"
        >Please enter a valid zip code.</div>
      </div>
    </div>
  </form>
</template>

<script>
import regions from "./../../utils/regions";

export default {
  name: "address-form",
  props: ["v", "mailingAddress"],
  data: function() {
    return {
      regions: regions
    };
  },
  methods: {
    onInput: function(field, value) {
      this.v[field].$touch();
      this.$emit(`update`, { ...this.mailingAddress, [field]: value });
    }
  }
};
</script>
